import "./Login.scss";

import axios from "axios";
import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import Alert from "ui/build/components/Alert/Alert";
import MonadModal from "ui/build/components/Modal/MonadModal";
import * as Yup from "yup";

import fetchEnv from "../../utils/FetchEnv";
import { t } from "../../utils/ResourceUtils";

const required = t("cm.please_fill_this_field");
const tooLong = t("cm.too_long");
const tooShort = t("cm.too_short");

const userData = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  securityAnswer1: "",
  securityAnswer2: "",
  securityAnswer3: "",
};

export const registerModalCatchHandler = ({ err, handleRegisterModal, setRegFormData, setShowAlert, setAlert }) => {
  setRegFormData(userData);
  setShowAlert(true);
  setAlert({
    alertType: "danger",
    message:
      err.response?.data?.message && typeof err.response.data.message === "string"
        ? err.response.data.message
        : "Failed to create the user",
  });
  handleRegisterModal(false);
};

export const registerModalResHandler = ({ setRegFormData, handleRegisterModal }) => {
  setRegFormData(userData);
  handleRegisterModal(false);
};
function RegisterModal({ open, handleRegisterModal }) {
  const [regFormData, setRegFormData] = useState(userData);
  const [showAlert, setShowAlert] = useState(false);
  const [alert, setAlert] = useState({
    alertType: "",
    message: "",
  });
  const tenantId = localStorage.getItem("tenantId");
  const handleChangeFun = (e, setFieldValue) => {
    const regFormData_ = { ...regFormData };
    regFormData_[e.target.name] = e.target.value;
    setRegFormData(regFormData_);
    setFieldValue(e.target.name, e.target.value);
  };
  const handleRegSubmit = async (e) => {
    const reqBody = {
      ...regFormData,
      managerEmailID: "venkat@datafoundry.ai",
      securityQuestion1: "What is your pet name?",
      securityQuestion2: "What is your place of birth?",
      securityQuestion3: "What is your first job?",
      tenantID: tenantId,
      roleNames: [2],
    };
    const reqHeaders = {
      headers: {
        "Accept-Language": "en",
      },
    };
    const admin_url = fetchEnv()?.REACT_APP_APIURL_ADMIN;
    await axios
      .post(`${admin_url}/authservice/v1/users/`, { ...reqBody }, { ...reqHeaders })
      .then((res) => {
        registerModalResHandler({ setRegFormData, handleRegisterModal });
      })
      .catch((err) => {
        registerModalCatchHandler({ err, handleRegisterModal, setRegFormData, setShowAlert, setAlert });
      });
  };

  const registrationSchema = Yup.object().shape({
    firstName: Yup.string().min(2, tooShort).max(50, tooLong).required(required),
    lastName: Yup.string().min(2, tooShort).max(50, tooLong).required(required),
    email: Yup.string().email(t("cm.invalid_email")).required(required),
    password: Yup.string().min(4, tooShort).max(50, tooLong).required(required),
    securityAnswer1: Yup.string().min(2, tooShort).max(50, tooLong).required(required),
    securityAnswer2: Yup.string().min(2, tooShort).max(50, tooLong).required(required),
    securityAnswer3: Yup.string().min(2, tooShort).max(50, tooLong).required(required),
  });

  return (
    <>
      {showAlert ? (
        <Alert
          alertType={alert.alertType}
          show={showAlert}
          dismiss={true}
          onClose={() => {
            setShowAlert(!showAlert);
          }}
        >
          {alert.message}
        </Alert>
      ) : null}
      <MonadModal
        className="reg-form-modal"
        variant="regular-modal"
        size="lg"
        open={open}
        body={
          <Formik
            initialValues={{
              ...userData,
            }}
            validationSchema={registrationSchema}
            onSubmit={(data) => {
              handleRegSubmit(data);
            }}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form>
                <div className="row w-100">
                  <div className="col-12 pr-0">
                    <div className="row mt-16">
                      <div className="col-6">
                        <div>{t("cm.first_name")}</div>
                        <Field
                          type="text"
                          variant="outlined"
                          name="firstName"
                          autoComplete="off"
                          ismandatory="true"
                          value={values.firstName}
                          data-testid="firstName"
                          onChange={(e) => handleChangeFun(e, setFieldValue)}
                        />
                        {errors.firstName && touched.firstName ? (
                          <div className="df-error-message">{errors.firstName}</div>
                        ) : null}
                      </div>
                      <div className="col-6">
                        <div>{t("cm.last_name")}</div>
                        <Field
                          type="text"
                          variant="outlined"
                          name="lastName"
                          autoComplete="off"
                          ismandatory="true"
                          value={values.lastName}
                          data-testid="lastName"
                          onChange={(e) => handleChangeFun(e, setFieldValue)}
                        />
                        {errors.lastName && touched.lastName ? (
                          <div className="df-error-message">{errors.lastName}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="row mt-16">
                      <div className="col-6">
                        <div>{t("cm.email_ID")}</div>
                        <Field
                          name="email"
                          type="email"
                          variant="outlined"
                          autoComplete="off"
                          ismandatory="true"
                          value={values.email}
                          data-testid="email"
                          onChange={(e) => handleChangeFun(e, setFieldValue)}
                        />
                        {errors.email && touched.email ? <div className="df-error-message">{errors.email}</div> : null}
                      </div>

                      <div className="col-6">
                        <div>{t("cm.password")}</div>
                        <Field
                          name="password"
                          label={t("cm.password")}
                          autoComplete="off"
                          variant="outlined"
                          ismandatory="true"
                          data-testid="passwordregister"
                          value={values.password}
                          onChange={(e) => handleChangeFun(e, setFieldValue)}
                        />
                        {errors.password && touched.password ? (
                          <div className="df-error-message">{errors.password}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="row mt-16">
                      <div className="col-6">
                        <div>{t("cm.what_is_your_pet_name")}</div>
                        <Field
                          type="text"
                          name="securityAnswer1"
                          variant="outlined"
                          value={values.securityAnswer1}
                          data-testid="securityAnswer1"
                          onChange={(e) => handleChangeFun(e, setFieldValue)}
                          ismandatory="true"
                        />
                        {errors.securityAnswer1 && touched.securityAnswer1 ? (
                          <div className="df-error-message">{errors.securityAnswer1}</div>
                        ) : null}
                      </div>
                      <div className="col-6">
                        <div>{t("cm.what_is_your_birth_place")}</div>
                        <Field
                          type="text"
                          name="securityAnswer2"
                          variant="outlined"
                          value={values.securityAnswer2}
                          data-testid="securityAnswer2"
                          onChange={(e) => handleChangeFun(e, setFieldValue)}
                          ismandatory="true"
                        />
                        {errors.securityAnswer2 && touched.securityAnswer2 ? (
                          <div className="df-error-message">{errors.securityAnswer2}</div>
                        ) : null}
                      </div>
                    </div>

                    <div className="row mt-16">
                      <div className="col-6">
                        <div>{t("cm.what_is_your_first_job")}</div>
                        <Field
                          type="text"
                          name="securityAnswer3"
                          variant="outlined"
                          value={values.securityAnswer3}
                          data-testid="securityAnswer3"
                          onChange={(e) => handleChangeFun(e, setFieldValue)}
                          ismandatory="true"
                        />
                        {errors.securityAnswer3 && touched.securityAnswer3 ? (
                          <div className="df-error-message">{errors.securityAnswer3}</div>
                        ) : null}
                      </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                      <div>
                        <button type="submit">{t("cm.submit")}</button>
                      </div>
                      <div>
                        <button className="cancel-btn" onClick={() => handleRegisterModal(false)}>
                          {t("cm.cancel")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        }
      />
    </>
  );
}

export default RegisterModal;
